import React from "react";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import ReactSelect from "react-select";
import Maximize from "../ui/Maximize";
import Minimize from "../ui/Minimize";
import { config } from "../../constants";
import MultiSelectDropdown from '../admin_components/pages/customComponents/MultiSelectDropdown';
import List, { ItemDragging } from 'devextreme-react/list';
import history from "../history";
import ConfirmationModal from "../ui/ConfirmationModal";
import { LoadPanel } from 'devextreme-react/load-panel';
import { compareLabel } from '../../utils/compare';
import apiClient from '../../utils/apiClient';

const url = config.url.URL;

const ListLoadUrl= `${url}/CriteriasMicroservice/Criteria`;
const MeasureLoadUrl = `${url}/CriteriasMicroservice/Measure`;
const CurrencyLoadUrl = `${url}/CriteriasMicroservice/Currency`;
const CorporateRateLoadUrl = `${url}/CriteriasMicroservice/CorporateRate`;

var FilterString = "";
var objects = [];

// Custom styles object
const customStyles = {
  // Styles for the container
  control: (provided) => ({
    ...provided,
    position: 'relative',
    width: '180px',
    top: '0',
    borderRadius: '0',
  }),

  // Styles for the dropdown menu list
  menuList: (provided) => ({
    ...provided,
    maxHeight: '200px !important',
    position: 'relative',
    width: '180px',
    fontSize: '12px',
    top: '0px',
  }),

  // Styles for the value container when options are selected
  valueContainer: (provided) => ({
    ...provided,
    maxHeight: '200px',
    width: '180px',
    overflowY: 'scroll !important',
    fontSize: '12px'
  }),

  // Styles for hiding the indicators (dropdown arrow)
  indicatorsContainer: (provided) => ({
    ...provided,
    display: 'none',
  }),

  // Styles for removing padding from list next button (if applicable)
  'list-next-button .button': (provided) => ({
    ...provided,
    padding: '0',
  }),

  // Additional styles for scrollable wrapper (if applicable)
  'scrollable-wrapper': (provided) => ({
    ...provided,
    paddingBottom: '0 !important',
  }),

  // Styles for the dropdown menu
  menu: (provided) => ({
    ...provided,
    top: '-215px',
    borderRadius: '0',
    width: '180px',
    height: '200px',
  }),
};


export default class ReportModal extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        CriteriaValues: [],
        PermanentCriteriaValues: [],
        CriteriaObjects: [],

        RowSelected: [],
        ColumnSelected: [],

        CurrenciesList: [],
        MeasuresList: [],
        CorporateRatesList: [],

        ListRowSelected: [],
        ListColumnSelected: [],
        toggle:[],
        toggle2:[],

        showModal:false,
        fullscreen: false,
        showConfirmationModal:false,

        optionsRowSelected: null,
        optionsColumnSelected: null,
        selectedRowIndex: "",
        loadPanelVisible: true,

        refsMap: {}
      };

      this.ReportName = React.createRef();
      this.FilterCriteria = React.createRef();

      this.onDragStart = this.onDragStart.bind(this);
      this.onAdd = this.onAdd.bind(this);
      this.onRemove = this.onRemove.bind(this);
      this.onReorder = this.onReorder.bind(this);

      this.populateCriteraObjects();
    }

    populateCriteraObjects = () =>{
      if (this.state.CriteriaObjects.length != 0){
        objects = this.state.CriteriaObjects;
        this.setState({loadPanelVisible: false})
        //console.log("object => ", objects);
      }else{
        setTimeout(this.populateCriteraObjects, 50);
      }
    }

    handleClose = () =>{
        this.setState({ showConfirmationModal: true })
    }

    doubleCloseModals = ()=> {
      this.setState({
        showModal: false,
        showConfirmationModal: false,
      });
    }

    closeConfirmationModal = ()=>{
      this.setState({ showConfirmationModal: false });
    }

    fullscreenHandler=()=>{
        this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
    }

    onDragStart(e) {
    e.itemData = this.state[e.fromData][e.fromIndex];
    }

    onAdd(e) {
      const tasks = this.state[e.toData] || [];
      const newTasks = [...tasks.slice(0, e.toIndex), e.itemData, ...tasks.slice(e.toIndex)];
    
      this.setState({
        [e.toData]: newTasks,
      }, this.updateReactSelects);
    }
    

    onRemove(e) {
      const tasks = this.state[e.fromData];
      const newTasks = tasks.filter((_, index) => index !== e.fromIndex);

      this.setState({
          [e.fromData]: newTasks,
      }, this.updateReactSelects);
    }

    onReorder(e) {
        this.onRemove(e);
        this.onAdd(e);
    }

    updateReactSelects() {
      const { ListRowSelected, ListColumnSelected } = this.state;
    
      this.setState({
        optionsRowSelected: (ListRowSelected || []).map(item => ({ value: item.value, label: item.label })),
        optionsColumnSelected: (ListColumnSelected || []).map(item => ({ value: item.value, label: item.label }))
      });
    }
    
  openModal = (e) => {

    this.setState({ showModal: true });

    let newCriteriaValues = [...this.state.PermanentCriteriaValues];

    this.setState({
      optionsRowSelected: null,
      optionsColumnSelected: null,
      ListRowSelected: null,
      ListColumnSelected: null,
      CriteriaValues: newCriteriaValues
    })

    setTimeout(function () {
      if (e.row == undefined) {
        this.refs.btnEdit.style.display = 'none';
        this.refs.btnNew.style.display = 'block';
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();
        const hours = String(today.getHours()).padStart(2, '0');
        const minutes = String(today.getMinutes()).padStart(2, '0');
        const formattedDate = `${year}${month}${day}_${hours}${minutes}`;
        this.ReportName.current.value = `Budget_Analysis_${formattedDate}`;
      } else {
        this.refs.btnEdit.style.display = 'block';
        this.refs.btnNew.style.display = 'none';
        //console.log(e.row.data.reportId);
        this.setState({ selectedRowIndex: e.row.data.reportId });
        this.refs.chkNet.checked = false;
        this.refs.chkEur.checked = false;
        this.fillReport();
      }
    }.bind(this), 50)

  }

  openSettings = (e) => {
    this.setState({ showModal: true });

    let newCriteriaValues = [...this.state.PermanentCriteriaValues];

    this.setState({
      optionsRowSelected: null,
      optionsColumnSelected: null,
      ListRowSelected: null,
      ListColumnSelected: null,
      CriteriaValues: newCriteriaValues
    })

    setTimeout(function () {
      this.refs.btnEdit.style.display = 'block';
      this.refs.btnNew.style.display = 'none';
      this.setState({ selectedRowIndex: e });
      this.refs.chkNet.checked = false;
      this.refs.chkEur.checked = false;
      this.fillReport();
    }.bind(this), 50)
  }

  //this function will fill the report settings from the data in Json format gotten from the microservice
  fillReport() {
    this.setState({ loadPanelVisible: true })

    apiClient(`${url}/ReportMicroservice/${this.state.selectedRowIndex}`)
      .then(response => {
        const data = response.data;
        this.ReportName.current.value = data.name;
        //this section is for filling the selected criterias in the Row section
        if (JSON.parse(data.config).RowIdList != []) {
          // Parsing the `RowIdList` from the `data.config` string and checking if it's not an empty array
          const filtered = this.state.CriteriaValues.filter(obj => {
            // Filtering the `CriteriaValues` array based on whether the `value` property is included in `RowIdList`
            return JSON.parse(data.config).RowIdList.includes(obj.value);
          });

          // Creating a copy of `RowIdList` array for sorting purposes
          var sortingArr = JSON.parse(data.config).RowIdList;
          // Updating the state with the filtered options and sorting the list based on the order of `sortingArr`
          this.setState({
            optionsRowSelected: filtered,
            ListRowSelected: filtered.slice().sort((a, b) => sortingArr.indexOf(a.value) - sortingArr.indexOf(b.value))
          })

          for (var a = 0; a < filtered.length; a++) {
            var index = this.state.CriteriaValues.indexOf(filtered[a]);
            this.state.CriteriaValues.splice(index, 1);
          }
        }

        //this section is for filling the selected criterias in the Column section
        if (JSON.parse(data.config).ColumnIdList != []) {
          const filtered = this.state.CriteriaValues.filter(obj => {
            return JSON.parse(data.config).ColumnIdList.includes(obj.value);
          });

          sortingArr = JSON.parse(data.config).ColumnIdList;
          this.setState({
            optionsColumnSelected: filtered,
            ListColumnSelected: filtered.slice().sort((a, b) => sortingArr.indexOf(a.value) - sortingArr.indexOf(b.value))
          })

          for (var a = 0; a < filtered.length; a++) {
            var index = this.state.CriteriaValues.indexOf(filtered[a]);
            this.state.CriteriaValues.splice(index, 1);
          }
        }

        //here we are setting the selected checkboxes for Net, Technical Cost, Fees, and Final Cost
        var CostIdListLenght = JSON.parse(data.config).CostIdList.length;
        for (let i = 0; i < CostIdListLenght; i++) {
          var checkedValue = this.state.MeasuresList.filter(obj => obj.measureId == JSON.parse(data.config).CostIdList[i])[0].name;

          this.refs.chkNet.checked = (checkedValue == "Net" || this.refs.chkNet.checked == true);
          this.refs.chkTechnical.checked = (checkedValue == "Technical Cost" || this.refs.chkTechnical.checked == true);
          this.refs.chkFees.checked = (checkedValue == "Fees" || this.refs.chkFees.checked == true);
          this.refs.chkCost.checked = (checkedValue == "Final Cost" || this.refs.chkCost.checked == true);
        }

        //here we are setting the selected checkboxes for currencies -> Euro, USD, Local
        var CurrencyIdListLenght = JSON.parse(data.config).CurrencyIdList.length;
        for (let i = 0; i < CurrencyIdListLenght; i++) {
          var checkedValue = this.state.CurrenciesList.filter(obj => obj.currencyId == JSON.parse(data.config).CurrencyIdList[i])[0].name;

          this.refs.chkEur.checked = (checkedValue == "EUR" || this.refs.chkEur.checked == true);
          this.refs.chkUsd.checked = (checkedValue == "USD" || this.refs.chkUsd.checked == true);
          this.refs.chkLocal.checked = (checkedValue == "LCL" || this.refs.chkLocal.checked == true);
        }

        //here we are setting the selected radioButton for Budget, R1, R2
        var checkedValue = this.state.CorporateRatesList.filter(obj => obj.corporateRateId == JSON.parse(data.config).RateId)[0].name;
        this.refs.chkBudget.checked = (checkedValue == "Budget");
        this.refs.chkR1.checked = (checkedValue == "R1");
        this.refs.chkR2.checked = (checkedValue == "R2");

        //here we are setting the selected checkboxe for Units
        var MeasureIdListLenght = JSON.parse(data.config).MeasureIdList.length;
        for (let i = 0; i < MeasureIdListLenght; i++) {
          var checkedValue = this.state.MeasuresList.filter(obj => obj.measureId == JSON.parse(data.config).MeasureIdList[i])[0].name;
          this.refs.chkUnits.checked = (checkedValue == "Units" || this.refs.chkUnits.checked == true);
        }

        const { refsMap } = this.state;

        //resetting all the dropdowns to empty array
        for (var a = 0; a < objects.length; a++) {
          const refName = "ddl" + objects[a].id;
          refsMap[refName].current.state.idsSelected = [];
        }

        apiClient(`${url}/ReportMicroservice/Scope/${data.scopeId}`)
          .then(response => {
            const data = response.data;
            let index = 0;

            for (let i = 0; i < data.length; i++) {
              let obj = data[i];

              this.getFiltersString();

              for (var a = 0; a < objects.length; a++) {
                const refName = "ddl" + objects[a].id;
                if (obj.name == objects[a].name) {
                  refsMap[refName].current.state.idsSelected.push(obj.id);
                  let microservice = "CriteriaValues";

                  // Checking if the current object's table name is "CalendarMonth" or "Sampling"
                  // If true, set the microservice to the object's name, otherwise keep it as "CriteriaValues"
                  if (objects[a].tableName == "CalendarMonth" || objects[a].tableName == "Sampling") { microservice = objects[a].name }

                  const criteriaData = {
                    FilterJson: FilterString,
                    CriteriaId: objects[a].id,
                    CriteriaName: objects[a].name,
                    HasFilter: objects[a].hasFilter,
                    ColumnName: objects[a].columnName
                };

                  // Reloading the dropdown using the microservice URL with the required parameters
                  refsMap[refName].current.reloadTheDd(`${url}/CriteriasMicroservice/${microservice}`, criteriaData, true);

                  this.refs["ref" + objects[a].id].style.display = 'block';
                  index = objects[a].index;
                }

                // Checking if the object's index is 1 -> applying the below only to the first item because the other items are already hidden from the render part
                if (objects[a].index == 1) {
                  // If the selected IDs array is empty, hide the reference element based on the object's ID
                  if (refsMap[refName].current.state.idsSelected.length == 0) {
                    this.refs["ref" + objects[a].id].style.display = 'none';
                  }
                }
              }
            }

            setTimeout(() => this.setState({ loadPanelVisible: false }), 4000);

            this.FilterCriteria.current.selectedIndex = index > 0 ? index - 1 : 0;
          });
      });
  }

      handleRowChange = (selected, actionMeta) => {
        this.setState({
          optionsRowSelected: selected,
          ListRowSelected: selected
        });
        //console.log(this.state.ListRowSelected);

        if (actionMeta["action"] == "select-option"){
          var index = this.state.CriteriaValues.indexOf(actionMeta["option"]);
          this.state.CriteriaValues.splice(index, 1);
        } else if (actionMeta["action"] == "remove-value"){
          this.state.CriteriaValues.push(actionMeta["removedValue"]);
          this.state.CriteriaValues.sort(compareLabel);
        }
        
      };
    
      handleColumnChange = (selected, actionMeta) => {
        this.setState({
          optionsColumnSelected: selected,
          ListColumnSelected: selected
        });
        //console.log(this.state.ListColumnSelected);

        if (actionMeta["action"] == "select-option"){
          var index = this.state.CriteriaValues.indexOf(actionMeta["option"]);
          this.state.CriteriaValues.splice(index, 1);
        } else if (actionMeta["action"] == "remove-value"){
          this.state.CriteriaValues.push(actionMeta["removedValue"]);
          this.state.CriteriaValues.sort(compareLabel);
        }

      };

      //the dataAccessString is used to save the data in the DataAccess table,
      //it is send to the microservice as string and then desirialized into class...
      getDataAccessString= (Name, ddl, getdata) =>{
        if(getdata == true && this.getcounthidden(ddl) > 0){
          return `{"Name":"${Name}", "Value":[${ddl.current.getSelectedOptions().map(x=>'"'+ x.value + '"')}]},`;
        }else{
          return '';
        }
      }
    
      //the filterString purpose is to filter the criterias values based on other selected criterias values
      //for example: if country is argentina then in agency show only agencies having country argentina
      getFiltersString = () => {
        FilterString = "";

        for(var a = 0; a < objects.length; a++)
        {
          const { refsMap } = this.state;
          const refName = "ddl" + objects[a].id;
          if (this.getcounthidden(refsMap[refName]) > 0)
            FilterString += `"${objects[a].id}":"${refsMap[refName].current.getSelectedOptions().map(x=> x.value)}",`;
        }
        
        FilterString = FilterString.substring(0, FilterString.length -1);
      }
    
      getcounthidden= (ddl) =>{
        var count;
        try{
          count = ddl.current.state.optionsSelected.length;
        }catch{
          count = 0;
        }
    
        return count;
      }
    
      //on each time the user opens a criteria dropdown we are retrieving the new filtered values from the microservice
  handleFilterCriteriaChange = (getdata) => {
    this.getFiltersString();
    var selectedOption = this.FilterCriteria.current.options[this.FilterCriteria.current.selectedIndex].text;

    let DataAccess = '';
    const { refsMap } = this.state;

    //we are looping through the Criteria objects array
    for (var a = 0; a < objects.length; a++) {
      const refName = "ddl" + objects[a].id;

      if (this.getcounthidden(refsMap[refName]) == 0 && selectedOption != objects[a].name) {
        this.refs["ref" + objects[a].id].style.display = 'none';
      } else {
        this.refs["ref" + objects[a].id].style.display = 'block';
        refsMap[refName].current.resetValues();

        //in order to improve the perfermance we only go through the below code if it's from dropdown click
        //getdata is a boolean variable we pass it when we call handleFilterCriteriaChange
        if (getdata) {
          let microservice = "CriteriaValues";
          if (objects[a].tableName == "CalendarMonth" || objects[a].tableName == "Sampling") {
            microservice = objects[a].name;
          }

          const criteriaData = {
            FilterJson: FilterString,
            CriteriaId: objects[a].id,
            CriteriaName: objects[a].name,
            HasFilter: objects[a].hasFilter,
            ColumnName: objects[a].columnName
          };

          refsMap[refName].current.reloadTheDd(`${url}/CriteriasMicroservice/${microservice}`, criteriaData);
        }

        DataAccess += this.getDataAccessString(objects[a].name, refsMap[refName], getdata);
      }
    }

    DataAccess = `{"DataAccess":[`.concat(DataAccess.length > 0 ? DataAccess.substring(0, DataAccess.length - 1) : ``).concat(`]}`);
    return DataAccess;
  };

  handleLoadingStart = () => {
    this.setState({ loadPanelVisible: true });
  };

  handleLoadingEnd = () => {
    this.setState({ loadPanelVisible: false });
  }
    
  onCreateReport = () => {
    let ReportName = this.ReportName.current.value;
    let Config = this.getConfigJson();

    if (Config == "notValid") {
      return;
    }

    let DataAccess = this.handleFilterCriteriaChange(true);

    let ReportInfo = {
      ReportName: ReportName,
      Config: Config,
      DataAccess: DataAccess
    };


    apiClient.post(`${url}/ReportMicroservice`, ReportInfo)
      .then(response => {
        const data = response.data;
        if (data) {
          this.handleClose();
          history.push({ pathname: "/report/reportView", state: { 'reportId': data } });
        }
      });
  }
    
  getConfigJson = () => {

    let isValid = true;
    document.getElementById('validationCost').style.borderLeft = 'none';
    document.getElementById('validationCost').style.paddingLeft = '0';
    document.getElementById('lblCost').style.color = 'rgb(51,51,51)';
    document.getElementById('lblCostRequired').style.display = 'none';

    document.getElementById('validationCurrencies').style.borderLeft = 'none';
    document.getElementById('validationCurrencies').style.paddingLeft = '0';
    document.getElementById('lblCurrencies').style.color = 'rgb(51,51,51)';
    document.getElementById('lblCurrenciesRequired').style.display = 'none';

    document.getElementById('divTopMsg').style.display = 'none';
    document.getElementById('lblMandatory').style.display = 'none';
    document.getElementById('lblAggregation').style.display = 'none';
    document.getElementById('lblaggregationCriteria').style.display = 'none';
    document.getElementById('lblPerimeter').style.color = 'black';

    document.getElementById('lblCriteria').style.display = 'none';
    document.getElementById('lblcriterion').style.display = 'none';
    document.getElementById('ListRowSelection').style.borderLeft = '1px solid lightgray';
    document.getElementById('ListColumnSelection').style.borderLeft = '1px solid lightgray';

    document.getElementById('lblFilterCriteria').style.display = 'none';
    document.getElementById('lblcriterionPerem').style.display = 'none';

    document.getElementById('lblReportName').style.color = 'black';
    document.getElementById('lblReportNameReq').style.display = 'none';

    if (this.ReportName.current.value == "") {
      document.getElementById('divTopMsg').style.display = 'block';
      document.getElementById('lblMandatory').style.display = 'block';
      document.getElementById('lblReportName').style.color = 'red';
      document.getElementById('lblReportNameReq').style.display = 'block';
      isValid = false;
    }

    const { refsMap } = this.state;

    if (this.getcounthidden(refsMap["ddlCalendarMonthId"]) != 0 || this.getcounthidden(refsMap["ddlCalendarQuarterId"]) != 0 || this.getcounthidden(refsMap["ddlCalendarSemesterId"]) != 0) {
      if (this.getcounthidden(refsMap["ddlCalendarYearId"]) == 0) {
        //toast.error('The criterion Month / Quarter / Semester cannot be selected if the year 2018 / 2019 is selected.');
        document.getElementById('divTopMsg').style.display = 'block';
        document.getElementById('lblFilterCriteria').style.display = 'block';
        document.getElementById('lblcriterionPerem').style.display = 'block';
        document.getElementById('lblPerimeter').style.color = 'red';
        isValid = false;
      } else {
        for (let i = 0; i < refsMap["ddlCalendarYearId"].current.getSelectedOptions().length; i++) {
          var item = refsMap["ddlCalendarYearId"].current.getSelectedOptions()[i];
          if (item.label == '2018' || item.label == '2019') {
            //toast.error('The criterion Month / Quarter / Semester cannot be selected if the year 2018 / 2019 is selected.');
            document.getElementById('divTopMsg').style.display = 'block';
            document.getElementById('lblFilterCriteria').style.display = 'block';
            document.getElementById('lblcriterionPerem').style.display = 'block';
            document.getElementById('lblPerimeter').style.color = 'red';
            isValid = false;
          }
        }
      }
    }

    this.state.RowSelected = [];
    if (this.state.ListRowSelected != null) { //optionsRowSelected

      for (let i = 0; i < this.state.ListRowSelected.length; i++) {

        var item = this.state.ListRowSelected[i];
        if (item.label == 'Month' || item.label == 'Quarter' || item.label == 'Semester') {

          if (this.getcounthidden(refsMap["ddlCalendarYearId"]) == 0) {
            //toast.error('The criterion Month / Quarter / Semester cannot be selected if the year 2018 / 2019 is selected.');
            document.getElementById('divTopMsg').style.display = 'block';
            document.getElementById('lblCriteria').style.display = 'block';
            document.getElementById('lblcriterion').style.display = 'block';
            document.getElementById('ListRowSelection').style.borderLeft = 'solid red';
            isValid = false;
          } else {
            for (let i = 0; i < refsMap["ddlCalendarYearId"].current.getSelectedOptions().length; i++) {
              var item = refsMap["ddlCalendarYearId"].current.getSelectedOptions()[i];
              if (item.label == '2018' || item.label == '2019') {
                //toast.error('The criterion Month / Quarter / Semester cannot be selected if the year 2018 / 2019 is selected.');
                document.getElementById('divTopMsg').style.display = 'block';
                document.getElementById('lblCriteria').style.display = 'block';
                document.getElementById('lblcriterion').style.display = 'block';
                document.getElementById('ListRowSelection').style.borderLeft = 'solid red';
                isValid = false;
              }
            }
          }
        }
      }

      this.state.ListRowSelected.map(select => {
        this.state.RowSelected.push(`"${select.value}"`);
      });
      //console.log(this.state.ListRowSelected);
    }

    this.state.ColumnSelected = [];
    if (this.state.ListColumnSelected != null) { //optionsColumnSelected

      for (let i = 0; i < this.state.ListColumnSelected.length; i++) {

        var item = this.state.ListColumnSelected[i];
        if (item.label == 'Month' || item.label == 'Quarter' || item.label == 'Semester') {

          if (this.getcounthidden(refsMap["ddlCalendarYearId"]) == 0) {
            //toast.error('The criterion Month / Quarter / Semester cannot be selected if the year 2018 / 2019 is selected.');
            document.getElementById('divTopMsg').style.display = 'block';
            document.getElementById('lblCriteria').style.display = 'block';
            document.getElementById('lblcriterion').style.display = 'block';
            document.getElementById('ListColumnSelection').style.borderLeft = 'solid red';
            isValid = false;
          } else {
            for (let i = 0; i < refsMap["ddlCalendarYearId"].current.getSelectedOptions().length; i++) {
              var item = refsMap["ddlCalendarYearId"].current.getSelectedOptions()[i];
              if (item.label == '2018' || item.label == '2019') {
                //toast.error('The criterion Month / Quarter / Semester cannot be selected if the year 2018 / 2019 is selected.');
                document.getElementById('divTopMsg').style.display = 'block';
                document.getElementById('lblCriteria').style.display = 'block';
                document.getElementById('lblcriterion').style.display = 'block';
                document.getElementById('ListColumnSelection').style.borderLeft = 'solid red';
                isValid = false;
              }
            }
          }
        }
      }

      this.state.ListColumnSelected.map(select => {
        this.state.ColumnSelected.push(`"${select.value}"`);
      });
    }

    let CostIdList = "";
    CostIdList += (this.refs.chkNet.checked ? (CostIdList.length > 0 ? ',' : "") + '"' + this.state.MeasuresList.filter(obj => obj.name == "Net")[0].measureId + '"' : "");
    CostIdList += (this.refs.chkTechnical.checked ? (CostIdList.length > 0 ? ',' : "") + '"' + this.state.MeasuresList.filter(obj => obj.name == "Technical Cost")[0].measureId + '"' : "");
    CostIdList += (this.refs.chkFees.checked ? (CostIdList.length > 0 ? ',' : "") + '"' + this.state.MeasuresList.filter(obj => obj.name == "Fees")[0].measureId + '"' : "");
    CostIdList += (this.refs.chkCost.checked ? (CostIdList.length > 0 ? ',' : "") + '"' + this.state.MeasuresList.filter(obj => obj.name == "Final Cost")[0].measureId + '"' : "");

    if (CostIdList == "") {
      //toast.error('Mandatory fields are missing. At least one cost is required');
      document.getElementById('validationCost').style.borderLeft = 'solid red';
      document.getElementById('validationCost').style.paddingLeft = '2px';
      document.getElementById('lblCost').style.color = 'red';
      document.getElementById('lblCostRequired').style.display = 'block';
      document.getElementById('divTopMsg').style.display = 'block';
      document.getElementById('lblMandatory').style.display = 'block';
      isValid = false;
    }

    let CurrenciesIdList = "";
    CurrenciesIdList += (this.refs.chkEur.checked ? (CurrenciesIdList.length > 0 ? ',' : "") + '"' + this.state.CurrenciesList.filter(obj => obj.name == "EUR")[0].currencyId + '"' : "");
    CurrenciesIdList += (this.refs.chkUsd.checked ? (CurrenciesIdList.length > 0 ? ',' : "") + '"' + this.state.CurrenciesList.filter(obj => obj.name == "USD")[0].currencyId + '"' : "");
    CurrenciesIdList += (this.refs.chkLocal.checked ? (CurrenciesIdList.length > 0 ? ',' : "") + '"' + this.state.CurrenciesList.filter(obj => obj.name == "LCL")[0].currencyId + '"' : "");

    if (CurrenciesIdList == "") {
      //toast.error('Mandatory fields are missing. At least one currency is required');
      document.getElementById('validationCurrencies').style.borderLeft = 'solid red';
      document.getElementById('validationCurrencies').style.paddingLeft = '2px';
      document.getElementById('lblCurrencies').style.color = 'red';
      document.getElementById('lblCurrenciesRequired').style.display = 'block';
      document.getElementById('divTopMsg').style.display = 'block';
      document.getElementById('lblMandatory').style.display = 'block';
      isValid = false;
    }

    var targetCurrency = false;
    if (this.refs.chkEur.checked || this.refs.chkUsd.checked) {
      targetCurrency = true;
    }

    if (this.refs.chkLocal.checked && targetCurrency) {
      //if(this.getcounthidden(this.ddlCurrency) != 1){ //this condition exist in pegasus but doesn't work when generate report
      //toast.error('Local aggregation is not possible when the scope of the report includes a local currency and an additional target currency.');
      document.getElementById('divTopMsg').style.display = 'block';
      document.getElementById('lblAggregation').style.display = 'block';
      document.getElementById('lblaggregationCriteria').style.display = 'block';
      document.getElementById('lblPerimeter').style.color = 'red';
      isValid = false;
      //}
    }

    let CorporateIdList = "";
    CorporateIdList += (this.refs.chkBudget.checked ? '"' + this.state.CorporateRatesList.filter(obj => obj.name == "Budget")[0].corporateRateId + '"' : "");
    CorporateIdList += (this.refs.chkR1.checked ? '"' + this.state.CorporateRatesList.filter(obj => obj.name == "R1")[0].corporateRateId + '"' : "");
    CorporateIdList += (this.refs.chkR2.checked ? '"' + this.state.CorporateRatesList.filter(obj => obj.name == "R2")[0].corporateRateId + '"' : "");

    let MeasureIdList = "";
    MeasureIdList += (this.refs.chkUnits.checked ? '"' + this.state.MeasuresList.filter(obj => obj.name == "Units")[0].measureId + '"' : "");

    return !isValid ? "notValid" : `{"RowIdList":[${this.state.RowSelected}],
        "ColumnIdList":[${this.state.ColumnSelected}],
        "CostIdList":[${CostIdList}],
        "CurrencyIdList":[${CurrenciesIdList}],
        "MeasureIdList":[${MeasureIdList}],
        "RateId":${CorporateIdList}}`
  }
    
  onEditReport = () => {
    //console.log(this.state.selectedRowIndex);

    let ReportId = this.state.selectedRowIndex;
    let ReportName = this.ReportName.current.value;
    let Config = this.getConfigJson();

    if (Config == "notValid") {
      return;
    }

    let DataAccess = this.handleFilterCriteriaChange(true);

    let ReportInfo = {
      ReportId: ReportId,
      ReportName: ReportName,
      Config: Config,
      DataAccess: DataAccess
    };

    apiClient.put(`${url}/ReportMicroservice`, ReportInfo)
      .then(response => {
        const data = response.data;
        if (data) {
          this.handleClose();
          history.push({ pathname: "/report/report" });
          history.push({ pathname: "/report/reportView", state: { 'reportId': ReportId } });
        }
      });
  }

    componentDidMount() {

      apiClient.get(ListLoadUrl)
        .then((response) => {
          const data = response.data;
          let values = data.map((item) => {
            return {
              label: item.name,
              value: item.criteriaId
            };
          });
          let permanentValues = [...values];
          this.state.CriteriaValues = values;
          this.state.PermanentCriteriaValues = permanentValues;

          let CriteriaObjects = data.map((item) => {
            return {
              name: item.name,
              id: item.columnId,
              index: item.order,
              hasFilter: item.showInAdmin,
              columnName: item.columnName,
              tableName: item.tableName
            };
          });
          this.state.CriteriaObjects = CriteriaObjects;
          this.updateReactSelects();
        });
  
      apiClient.get(MeasureLoadUrl)
        .then((response) => {
          const data = response.data;
          this.state.MeasuresList = data;
          this.setState({
            MeasuresList: data
          });
        });
  
      apiClient.get(CurrencyLoadUrl)
        .then((response) => {
          const data = response.data;
          this.state.CurrenciesList = data;
          this.setState({
            CurrenciesList: data
          });
        });
        
      apiClient.get(CorporateRateLoadUrl)
        .then((response) => {
          const data = response.data;
          this.state.CorporateRatesList = data;
          this.setState({
            CorporateRatesList: data
          });
        });
    }

    showRowSelection=()=>{
        document.getElementById("ddlRowSelection").style.display = "block";
        document.getElementById("ListRowSelection").style.display = "none";
    
        document.getElementById("btnHideRowSelection").style.display = "block";
        document.getElementById("btnShowRowSelection").style.display = "none";
      }
    
      hideRowSelection=()=>{
        document.getElementById("ddlRowSelection").style.display = "none";
        document.getElementById("ListRowSelection").style.display = "block";
    
        document.getElementById("btnHideRowSelection").style.display = "none";
        document.getElementById("btnShowRowSelection").style.display = "block";
      }
    
      showColumnSelection=()=>{
        document.getElementById("ddlColumnSelection").style.display = "block";
        document.getElementById("ListColumnSelection").style.display = "none";
    
        document.getElementById("btnHideColumnSelection").style.display = "block";
        document.getElementById("btnShowColumnSelection").style.display = "none";
      }
    
      hideColumnSelection=()=>{
        document.getElementById("ddlColumnSelection").style.display = "none";
        document.getElementById("ListColumnSelection").style.display = "block";
    
        document.getElementById("btnHideColumnSelection").style.display = "none";
        document.getElementById("btnShowColumnSelection").style.display = "block";
      }

      toggleButton1() {
        const toggling = this.state.toggle;
        let newCriteriaValues = [...this.state.PermanentCriteriaValues];

        if(toggling.length){
          this.setState({ ListRowSelected: [] ,optionsRowSelected: [], toggle:[], CriteriaValues:newCriteriaValues});
        }else{
          if (this.state.CriteriaValues.length != 0){
            this.setState({ListRowSelected: newCriteriaValues, optionsRowSelected: newCriteriaValues, toggle: newCriteriaValues, CriteriaValues:[]});
          }
        }

        if(this.state.optionsColumnSelected != null){
          for (var a = 0; a < this.state.optionsColumnSelected.length; a++){
            var index = newCriteriaValues.indexOf(this.state.optionsColumnSelected[a]);
            newCriteriaValues.splice(index,1);
          }
        }

      };

      toggleButton2() {
        const toggling2 = this.state.toggle2;
        let newCriteriaValues = [...this.state.PermanentCriteriaValues];

        if(toggling2.length){
          this.setState({ ListColumnSelected: [] , optionsColumnSelected: [], toggle2:[], CriteriaValues:newCriteriaValues});
        }else{
          if (this.state.CriteriaValues.length != 0){
            this.setState({ListColumnSelected: newCriteriaValues, optionsColumnSelected: newCriteriaValues, toggle2: newCriteriaValues, CriteriaValues:[]});
          }
        }

        if(this.state.optionsRowSelected != null){
          for (var a = 0; a < this.state.optionsRowSelected.length; a++){
            var index = newCriteriaValues.indexOf(this.state.optionsRowSelected[a]);
            newCriteriaValues.splice(index,1);
          }
        }
        
      };

      render() {
        let l_FilterCriteria = this.state.PermanentCriteriaValues;
        let optionFilterCriteria = l_FilterCriteria.map((filter) =>
            <option key={filter.value} value={filter.value}>{filter.label}</option>
        );
    
        const { refsMap } = this.state;
        for (var a = 0; a < objects.length; a++) {
            const refName = "ddl" + objects[a].id;
            refsMap[refName] = React.createRef();
            //console.log(refsMap[refName], "created");
        }
    
        const customNoOptionsMessage = () => {
          return "No entries available with current selection";
        };

        return (
            <>
                <Modal show={this.state.showModal} onHide={this.handleClose} size="budget-analysis" centered fullscreen={this.state.fullscreen}>
                    <Modal.Header closeButton>
                        <Modal.Title size="h6">New Report : Budget Analysis</Modal.Title>
                        <button type="button" class="btn btn-primary report-btn-2" onClick={this.fullscreenHandler}>
                            {this.state.fullscreen ? <Maximize /> : <Minimize />}
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <row>
                            <div id='divTopMsg' style={{ border: 'solid 1px red', marginBottom: '5px', display: 'none' }}>
                                <div style={{ margin: '7px', display: 'grid' }}>
                                    <label id="lblAggregation" className="font-col-weight">Local aggregation is not possible when the scope of the report includes a local currency and an additional target currency.</label>
                                    <label id="lblMandatory" className="font-col-weight">Mandatory fields are missing.</label>
                                    <label id="lblCriteria" className="font-col-weight">Criteria selection is incompatible with current report perimeter.</label>
                                    <label id="lblFilterCriteria" className="font-col-weight">Filter selection is incompatible with current report perimeter.</label>
                                    <label className="font-col-weight">Report generation is not allowed.</label>
                                </div>
                            </div>
                        </row>
                        <Row>
                            <Form.Group className="mb-3 col-md-12" controlId="Name">
                                <Form.Label id="lblReportName">Report Name</Form.Label>
                                <Form.Control type="text" ref={this.ReportName} placeholder="Report Name" />
                                <label id='lblReportNameReq' className="font-col-weight-11" style={{ marginTop: '5px', display: 'none' }}>The Report Name field is Required</label>
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group className="mb-3 col-md-12" controlId="Name">
                                <Form.Label id="lblPerimeter">Report Perimeter Filter</Form.Label>
                                <Row style={{ marginBottom: '-25px' }}>
                                    <Form.Group style={{ display: 'flex', marginBottom: '15px' }}>
                                        <Form.Label style={{ marginTop: '9px' }}>Filter Criteria:</Form.Label>&nbsp;&nbsp;
                                        <Form.Control 
                                        ref={this.FilterCriteria} 
                                        required 
                                        as="select" 
                                        style={{ width: '230px', height: '35px' }} 
                                        onChange={event => this.handleFilterCriteriaChange(false)}
                                        className="select-placeholder"
                                        defaultValue=""
                                        >
                                            {optionFilterCriteria}
                                        </Form.Control>
                                    </Form.Group>
    
                                    {objects.map((object) => (
                                      <Form.Group
                                        key={object.id}
                                        className="mb-3 col-md-12"
                                        ref={"ref" + object.id}
                                        style={object.index == 1 ? { display: 'block' } : { display: 'none' }}>
                                        <Form.Label>{object.name}</Form.Label>
                                        <MultiSelectDropdown
                                          loadUrl=""
                                          isMulti={true}
                                          idColumnName="criteriaId"
                                          ref={refsMap["ddl" + object.id]}
                                          handleFilterCriteriaChange={event => this.handleFilterCriteriaChange(true)}
                                          customNoOptionsMessage="No entries available with current selection"
                                          filterIsEnabledOnly={false}
                                          onLoadingStart={this.handleLoadingStart}
                                          onLoadingEnd={this.handleLoadingEnd}
                                        />
                                      </Form.Group>
                                    ))}
                                </Row>
                            </Form.Group>
                        </Row>
                        <label id='lblaggregationCriteria' className="font-col-weight-11" style={{ display: 'none' }}>Local aggregation is not possible when the scope of the report includes a local currency and an additional target currency.</label>
                        <label id='lblcriterionPerem' className="font-col-weight-11" style={{ display: 'none' }}>The criterion Month / Quarter / Semester cannot be selected if the year 2018 / 2019 is selected.</label>
                        <hr />
                        <Row style={{ marginBottom: '-20px' }}>
                            <Form.Group className="mb-3 col-md-6 selection-scroll" controlId="Name">
                                <Row>
                                    <Form.Group className="mb-3 col-md-6" controlId="Name">
                                        <Form.Label>Row Selection</Form.Label>
                                        <div id="ListRowSelection" style={{ display: 'block' }} className="container-border">
                                            <List
                                                style={{ height: '200px' }}
                                                dataSource={this.state.ListRowSelected}
                                                keyExpr="value"
                                                displayExpr="label"
                                                repaintChangesOnly={true}
                                                allowItemDeleting={false}>
                                                <ItemDragging
                                                    allowReordering={true}
                                                    group="selectionGroup"
                                                    data="ListRowSelected"
                                                    onDragStart={this.onDragStart}
                                                    onAdd={this.onAdd}
                                                    onRemove={this.onRemove}
                                                    onReorder={this.onReorder}>
                                                </ItemDragging>
                                            </List>                                    
                                        </div>
                                        <br />
                                        <div id="ddlRowSelection" style={{ display: 'none' }}>
                                            <ButtonBootstrap className="check-btn" onClick={this.toggleButton1.bind(this)}>Check/Uncheck All</ButtonBootstrap>
                                            <ReactSelect
                                                styles={customStyles}
                                                options={this.state.CriteriaValues}
                                                isMulti={true}
                                                closeMenuOnSelect={false}
                                                onChange={this.handleRowChange}
                                                value={this.state.optionsRowSelected}
                                                menuIsOpen={true}
                                                noOptionsMessage={customNoOptionsMessage}
                                                filterOption={(option, inputValue) =>
                                                  option.label &&
                                                  option.label.toLowerCase().includes(inputValue.toLowerCase())
                                                }
                                            />
                                        </div>
                                        <div id="btnShowRowSelection" style={{ float: 'right', marginRight: '-20px', display: 'block' }}>
                                            <p onClick={this.showRowSelection} className="p-color">&#8853; Set Row Selection</p>
                                        </div>
                                        <div id="btnHideRowSelection" className="validate-btn" style={{ display: 'none' }}>
                                            <p onClick={this.hideRowSelection} className="p-color">&#8853; Validate</p>
                                        </div>
                                    </Form.Group>
                                    <Form.Group className="mb-3 col-md-6" controlId="Name">
                                        <Form.Label>Column Selection</Form.Label>
                                        <div id="ListColumnSelection" style={{ display: 'block' }} className="container-border">
                                            <List
                                                style={{ height: '200px' }}
                                                dataSource={this.state.ListColumnSelected}
                                                keyExpr="value"
                                                displayExpr="label"
                                                repaintChangesOnly={true}>
                                                <ItemDragging
                                                    allowReordering={true}
                                                    group="selectionGroup"
                                                    data="ListColumnSelected"
                                                    onDragStart={this.onDragStart}
                                                    onAdd={this.onAdd}
                                                    onRemove={this.onRemove}
                                                    onReorder={this.onReorder}>
                                                </ItemDragging>
                                            </List>                                      
                                        </div>
                                        <br />
                                        <div id="ddlColumnSelection" style={{ display: 'none' }}>
                                            <ButtonBootstrap className="check-btn" onClick={this.toggleButton2.bind(this)}>Check/Uncheck All</ButtonBootstrap>
                                            <ReactSelect
                                                styles={customStyles}
                                                options={this.state.CriteriaValues}
                                                isMulti={true}
                                                closeMenuOnSelect={false}
                                                onChange={this.handleColumnChange}
                                                value={this.state.optionsColumnSelected}
                                                menuIsOpen={true}
                                                noOptionsMessage={customNoOptionsMessage}
                                                filterOption={(option, inputValue) =>
                                                  option.label &&
                                                  option.label.toLowerCase().includes(inputValue.toLowerCase())
                                                }                                                
                                            />
                                          </div>
                                        <div id="btnShowColumnSelection" style={{ float: 'right', marginRight: '0px', display: 'block' }}>
                                            <p onClick={this.showColumnSelection} className="p-color">&#8853; Set Column Selection</p>
                                        </div>
                                        <div id="btnHideColumnSelection" className="validate-btn" style={{ display: 'none' }}>
                                            <p onClick={this.hideColumnSelection} className="p-color">&#8853; Validate</p>
                                        </div>
                                    </Form.Group>
                                </Row>
                                <Row>
                                    <label id='lblcriterion' className="font-col-weight-11" style={{ marginTop: '-15px', display: 'none' }}>The criterion Month / Quarter / Semester cannot be selected if the year 2018 / 2019 is selected.</label>
                                </Row>
                            </Form.Group>
                            <Form.Group className="mb-3 col-md-2" controlId="chkCost" style={{ marginRight: '15px' }}>
                                <Form.Label id="lblCost">Costs</Form.Label>
                                <div id="validationCost" style={{ height: '96px' }}>
                                    <Form.Check type="checkbox" label="Net" ref="chkNet" defaultChecked />
                                    <Form.Check type="checkbox" label="Technical Cost" ref="chkTechnical" />
                                    <Form.Check type="checkbox" label="Fees" ref="chkFees" />
                                    <Form.Check type="checkbox" label="Final Cost" ref="chkCost" />
                                </div>
                                <label id='lblCostRequired' className="font-col-weight-11" style={{ marginTop: '22px', display: 'none' }}>At least one cost is required</label>
                            </Form.Group>
                            <Form.Group className="mb-3 col-md-1" controlId="chkCurrencies" style={{ marginLeft: '-20px', marginRight: '15px' }}>
                                <Form.Label id="lblCurrencies">Currencies</Form.Label>
                                <div id="validationCurrencies" style={{ height: '69px' }}>
                                    <Form.Check type="checkbox" label="EUR" ref="chkEur" defaultChecked />
                                    <Form.Check type="checkbox" label="USD" ref="chkUsd" />
                                    <Form.Check type="checkbox" label="Local" ref="chkLocal" />
                                </div>
                                <label id='lblCurrenciesRequired' className="font-col-weight-11" style={{ marginTop: '20px', display: 'none' }}>At least one currency is required</label>
                            </Form.Group>
                            <Form.Group className="mb-3 col-md-2" controlId="chkCorporate">
                                <Form.Label>Corporate Rate</Form.Label>
                                <Form.Check type="radio" name="Corporate" label="Budget" ref="chkBudget" defaultChecked />
                                <Form.Check type="radio" name="Corporate" label="R1" ref="chkR1" />
                                <Form.Check type="radio" name="Corporate" label="R2" ref="chkR2" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-md-1" controlId="chkMeasures" style={{ marginLeft: '-30px' }}>
                                <Form.Label>Measures</Form.Label>
                                <Form.Check type="checkbox" label="Units" ref="chkUnits" />
                            </Form.Group>
                        </Row>
    
                        <LoadPanel
                            //shadingColor="rgba(0,0,0,0.4)"
                            visible={this.state.loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
    
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonBootstrap ref="btnNew" variant="primary" className='btnPrimary' style={{ display: 'none' }} onClick={this.onCreateReport}>
                            Generate Report
                        </ButtonBootstrap>
                        <ButtonBootstrap ref="btnEdit" variant="primary" className='btnPrimary' style={{ display: 'none' }} onClick={this.onEditReport}>
                            Generate Report
                        </ButtonBootstrap>
                        <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
                            Cancel
                        </ButtonBootstrap>
                    </Modal.Footer>
                </Modal>
                <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Are you sure you want to leave this page ?" />
            </>
        );
      }
}